import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import { changePlanThunk } from '../../redux/thunks/subscription';
import { settingSelectedPlan } from '../../redux/slices/subscription';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const SelectedPlanCheckoutComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { selectedPlan, prorateCharge } = useSelector((state: RootState) => state.subscription);

    const cancelHandler = () => {
        dispatch(settingSelectedPlan(null));
    };

    const switchPlanHandler = async () => {
        try {
            await dispatch(changePlanThunk()).unwrap();
            dispatch(settingSelectedPlan(null));
        } catch (e) {
            //
        }
    };

    return <Box py={2}>
        <CardWrapper>
            <Typography variant="h3" gutterBottom>Checkout</Typography>
            <CardWrapper>
                <Typography variant="h6">Summary</Typography>
                <Box display="flex" justifyContent="space-between" mb={2} pt={2}>
                    <Box>
                        <Typography variant="subtitle2" fontWeight="bold" color="textSecondary">New Plan: <Typography component="span" variant="subtitle2" fontWeight="bold" color={brand[300]}>{selectedPlan?.product_name.toLocaleUpperCase()}</Typography></Typography>
                        <Typography variant="subtitle2" fontWeight="bold">Subscription period: <Typography component="span" variant="subtitle2" fontWeight="bold" color={brand[300]}>Feb 12, 2026 to Feb 12, 2027</Typography></Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="textSecondary">Due bill: <Typography component="span" variant="subtitle2" fontWeight="bold">${prorateCharge}</Typography></Typography>
                    </Box>
                </Box>
                <Divider />
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <Typography variant="body1" color="textDisabled">Note: Remaining balance in your account will be $0 which will be used for future purchases</Typography>
                    <Box display="flex" justifyContent="end" gap={2}>
                        <Button variant="outlined" size="large" color="secondary" onClick={cancelHandler}>Cancel</Button>
                        <Button variant="contained" size="large" onClick={switchPlanHandler}>Update the plan</Button>
                    </Box>
                </Box>
            </CardWrapper>
        </CardWrapper>
    </Box>;
};

export default SelectedPlanCheckoutComponent;